export const linkify = (text) => {
  const urlRegex = /(\bhttps?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]*[-A-Za-z0-9+&@#/%=~_|])(?![^<]*>|[^<>]*<\/a>)/gi;
  return text.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
};

export const hasHtmlLinks = (text) => /<a\s+href=/i.test(text);

export const stripHtml = (text) => text.replace(/<[^>]+>/g, '');